import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SearchRoom from './SearchRoom';
import { useTranslation } from 'react-i18next';

function Slider() {
    const [banners, setBanners] = useState([]);
    const { t } = useTranslation();
    const [AmenitiesData, setAmenitiesData] = useState([]);
    const [showMoreRoom, setShowMoreRoom] = useState(false);
    const [showMoreCommon, setShowMoreCommon] = useState(false);
    const [descriptions, setDescriptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/banner_image_list"
      );
      setBanners(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
  const fetchDescriptions = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/list_description"
      );

      const reverseDate = response.data.data.reverse()
      setDescriptions(reverseDate);
    } catch (error) {
      console.error("Error fetching descriptions:", error);
    }
  };

  fetchDescriptions();
}, []);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/amenity_list"
          );
          setAmenitiesData(response.data.data || []);
        } catch (error) {
          console.error("Error fetching amenities data:", error);
        }
      };
  
      fetchData();
    }, []);
  
    // Filter amenities by type
    const roomAmenities = AmenitiesData.filter(
      (item) => item.amenity_types === "Room Amenities"
    );
    const commonAmenities = AmenitiesData.filter(
      (item) => item.amenity_types === "Common Amenities"
    );
  
    const visibleRoomAmenities = showMoreRoom ? roomAmenities : roomAmenities.slice(0, 6);
    const visibleCommonAmenities = showMoreCommon ? commonAmenities : commonAmenities.slice(0, 6);


  return (
    <>
    <div className="home-slider" style={{ marginTop: "150px", border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}>
      <div style={{ padding: "20px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
          Welcome To Nagpur
        </h1>
       <div
  style={{
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "center",
    padding: "20px",
  }}
>
  <p dangerouslySetInnerHTML={{ __html: descriptions[0]?.description }}></p>
</div>
      </div>
      {banners.map((banner) => (
        <img  src={`https://cyberathon.com/silverapartment/${banner.banner_img}`} fetchpriority="high" alt='Hotel Banner'/>
      ))}
    </div>
    <div className="container-fluid amenities-div">

      {/* COMMON AMENITIES */}
      <div className="row aminities-detail">
        <h1 style={{fontSize:"38px", display:"flex", alignItems:"center", justifyContent:"center"}}>{t("common")}</h1>
        {visibleCommonAmenities.map((item, index) => (
          <div key={index} className="col-lg-3 col-sm-6">
            <div className="service-item">
              <img
                src={`https://cyberathon.com/silverapartment/${item.icon_amenty}`}
                alt={item.title}
                loading="lazy"
                className="red-svg"
              />
              <h2 style={{fontSize:"25px", margin:"10px"}}>{item.title}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}

        {commonAmenities.length > 6 && (
          <div className="text-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setShowMoreCommon(!showMoreCommon)}
            >
              {showMoreCommon ? t("show_less") : t("show_more")}
            </button>
          </div>
        )}
      </div>

      {/* ROOM AMENITIES */}
      <div className="row spad1 aminities-detail">
        <h1 style={{fontSize:"35px", display:"flex", alignItems:"center", justifyContent:"center"}}>{t("room_amenities_title")}</h1>
        {visibleRoomAmenities.map((item, index) => (
          <div key={index} className="col-lg-2 col-sm-6 col-12 room-amenities">
            <div className="service-item">
              <img
                src={`https://cyberathon.com/silverapartment/${item.icon_amenty}`}
                alt={item.title}
                loading="lazy"
                className="red-svg"
              />
              <h2 style={{fontSize:"25px", margin:"10px"}}>{item.title}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}

        {roomAmenities.length > 6 && (
          <div className="text-center mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setShowMoreRoom(!showMoreRoom)}
            >
              {showMoreRoom ? t("show_less") : t("show_more")}
            </button>
          </div>
        )}
      </div>
    </div>
    <div
  style={{
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "center",
    padding: "20px",
  }}
>
<p dangerouslySetInnerHTML={{ __html: descriptions[1]?.description }}></p>
</div>


      <div style={{ overflow: "hidden", minHeight: "200px" }}>
  <div
    className="elfsight-app-697384dc-d1cc-4902-9334-8f06770f5224"
    data-elfsight-app-lazy
  ></div>
</div>

    <div
  style={{
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "center",
    padding: "20px",
  }}
>
<p dangerouslySetInnerHTML={{ __html: descriptions[2]?.description }}></p>
</div>

    <div
  style={{
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "center",
    padding: "20px",
  }}
>
<p dangerouslySetInnerHTML={{ __html: descriptions[3]?.description }}></p>
</div>
    {/* <SearchRoom/> */}
    </>
  );
}

export default Slider;
